import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import DocumentScoringContainer from 'features/document/edit/scoring/components/DocumentScoringContainer';
import FolderCommentsCardContainer from 'features/folder/edit/comments/components/FolderCommentsCardContainer';
import { RightsContext } from 'providers/RightsContext';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Typography } from '@mui/material';
const FolderScoringContainer = ({ documentId, siteId, history }) => {
  const viewScoringHistory = () => {
    history.push(`/folders/${documentId}/${siteId}/historyscoring`);
  };
  const { isImage } = useContext(RightsContext);
  const { t } = useTranslation();
  return !isImage ? (
    <>
      <DocumentScoringContainer documentId={documentId} siteId={siteId} viewScoringHistory={viewScoringHistory} isFolder />
      <FolderCommentsCardContainer documentId={documentId} siteId={siteId} />
    </>
  ) : (
    <Card>
      <CardContent>
        <Typography>
          <strong> {t('DocumentEdit.Scoring.ScoringHistoryMessage')} </strong>
        </Typography>
      </CardContent>
    </Card>
  );
};

FolderScoringContainer.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  history: PropTypes.object.isRequired
};

export default FolderScoringContainer;
